import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './licitacionesPublicas.css';

const LicitacionesPublicas = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div className='ldf_titulo'>
                <h2>Licitaciones Públicas</h2>
                <hr className='hr-gob'/>
            </div>

            <table className="table table-striped table-bordered tabla_elementos">
                <tbody>
                    <tr>
                        <td>2016</td>
                        <td>2017</td>
                        <td>2018</td>
                        <td>2019</td>
                        <td>2020</td>
                    </tr>
                    <tr>
                        <td><h3><Link to="DetalleLicitacion/DetalleLicitacion2021">2021</Link></h3></td>
                        <td><h3><Link to="DetalleLicitacion/DetalleLicitacion2022">2022</Link></h3></td>
                        <td><h3><Link to="DetalleLicitacion/DetalleLicitacion2023">2023</Link></h3></td>
                        <td><h3><Link to="DetalleLicitacion/DetalleLicitacion2024">2024</Link></h3></td>
                        <td><h3><Link to="DetalleLicitacion/DetalleLicitacion2025">2025</Link></h3></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
         </div>
     </div>
  )
}

export default LicitacionesPublicas